import { toggleSideBarCollapsed } from "@Store/App/actions";
import { selectSideBarCollapsed } from "@Store/App/selectors";
import {
  selectCurrentOrganization,
  selectOrganizationsGeneralData,
} from "@Store/Organizations/selectors";
import { useAppDispatch, useAppSelector } from "@hooks";
import { SideBarManipulator } from "@src/commonStyles";
import { UnmountClosed } from "react-collapse";
import HamburgerMenu from "react-hamburger-menu";
import { useTranslation } from "react-i18next";
import { Menu, MenuItem, ProSidebar, SubMenu } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link, useRouteMatch } from "react-router-dom";
import { Container, SidebarContainer, SidebarItemContainer } from "./styles";

function SideBar() {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const dispatch = useAppDispatch();

  const currentOrganization = useAppSelector(selectCurrentOrganization);
  const { isLoading } = useAppSelector(selectOrganizationsGeneralData);
  const sideBarCollapsed = useAppSelector(selectSideBarCollapsed);

  if (!currentOrganization?.orgId && !isLoading) return null;

  const orgDataDefaultOpen = path.includes("data") || path.includes("admins");
  const appSettingsDefaultOpen =
    path.includes("users") || path.includes("teams");

  return (
    <Container>
      <SideBarManipulator onClick={() => dispatch(toggleSideBarCollapsed())}>
        <HamburgerMenu
          isOpen={sideBarCollapsed}
          menuClicked={() => {}}
          width={18}
          height={15}
          strokeWidth={1}
          rotate={0}
          color="white"
          borderRadius={0}
          animationDuration={0.5}
        />
      </SideBarManipulator>
      <UnmountClosed isOpened={sideBarCollapsed}>
        <SidebarContainer>
          <ProSidebar>
            <Menu subMenuBullets={true}>
              <SidebarItemContainer color={"white"}>
                <MenuItem
                  className={path.includes("overview") ? "subMenuActive" : ""}
                >
                  {t("sidebar.overview")}
                  <Link
                    to={`/organization/${currentOrganization?.orgId}/overview`}
                  />
                </MenuItem>
              </SidebarItemContainer>
              <SidebarItemContainer color={"mainYellow"}>
                <SubMenu
                  title={t("sidebar.organization.data")}
                  className={orgDataDefaultOpen ? "subMenuActive" : ""}
                  defaultOpen
                >
                  {/*<MenuItem active={path.includes("data")}>*/}
                  {/*  {t("sidebar.organization.info")}*/}
                  {/*  <Link*/}
                  {/*    to={`/organization/${currentOrganization?.orgId}/data`}*/}
                  {/*  />*/}
                  {/*</MenuItem>*/}
                  <MenuItem active={path.includes("admins")}>
                    {t("sidebar.organization.admins")}
                    <Link
                      to={`/organization/${currentOrganization?.orgId}/admins`}
                    />
                  </MenuItem>
                </SubMenu>
              </SidebarItemContainer>
              <SidebarItemContainer color={"mainRed"}>
                <SubMenu
                  title={t("sidebar.app.title")}
                  className={appSettingsDefaultOpen ? "subMenuActive" : ""}
                  defaultOpen
                >
                  <MenuItem active={path.includes("users")}>
                    {t("sidebar.app.users")}
                    <Link
                      to={`/organization/${currentOrganization?.orgId}/users`}
                    />
                  </MenuItem>
                  {/*<MenuItem active={path.includes("teams")}>*/}
                  {/*  {t("sidebar.app.teams")}*/}
                  {/*  <Link*/}
                  {/*    to={`/organization/${currentOrganization?.orgId}/teams`}*/}
                  {/*  />*/}
                  {/*</MenuItem>*/}
                </SubMenu>
              </SidebarItemContainer>
            </Menu>
          </ProSidebar>
        </SidebarContainer>
      </UnmountClosed>
    </Container>
  );
}

export default SideBar;
